import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'provideButtonLabel'
})
export class ProvideButtonLabelPipe implements PipeTransform {

  transform(meta: any,value: any,state:number) {
    if(!state){
        if(value==0){
            return meta[0]
        }else {
            return meta[1]
        }
    }else{
        if(value==3){
            return meta[3]
        }else{
            return meta[2]
        }
    }
    
  }
}